import React, { useEffect, useMemo, useRef, useState } from "react";
import OutlineButton from "../../../../../../components/OutlineButton/OutlineButton";
import { FileDrop } from "react-file-drop";
import FileUpload from "../../../../../../assets/svgComponent/FileUpload";
import { selectOrganisation } from "../../../../../../redux/selectors/organisation";
import { useDispatch, useSelector } from "react-redux";
import ExcelJS from "exceljs";
import { doCreateNotification } from "../../../../../../redux/actionCreators/miscellaneous";
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import Dropdown from "../../../../../../components/Inputs/Dropdown";
import Table from "../../../../../../components/Table/Table";
import { Delete, Edit } from "@material-ui/icons";
import Button from "../../../../../../components/Buttons/Button";
import {
    cardFormatMap,
    credType1Headers,
    credType2Headers,
    credTypes,
    detectDuplicateEmails,
    dynamicQRTypes,
    formats,
    staticQRTypes,
    validateCredsData
} from "../helper";
import GenerateNewCredential from "../Forms/GenerateNewCredential";
import { validEmail } from "../../../../../../helpers/utils/formValidations";
import FlexColumn from "../../../../../../components/FlexBox/FlexColumn";


const BulkUploadCredential = ({ bulkSteps = 1, assignmentMethod, setBulkSteps, setBulkAddData, qrMode, credentialType }) => {
    const dispatch = useDispatch();

    const { organisation } = useSelector((state) => ({
        organisation: selectOrganisation(state),
    }));

    const [credsData, setCredsData] = useState([]);
    const [credsHeaders, setCredsHeaders] = useState([]);
    const [headersMap, setHeadersMap] = useState({});
    const [formattedData, setFormattedData] = useState([]);
    const [credDelete, setCredDelete] = useState({ show: false, data: {} });
    const [credUpdate, setCredUpdate] = useState({ show: false, data: {} });
    const [selectedFormat, setSelecetdFormat] = useState({ id: '', name: '' });
    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [credentialId, setCredentialId] = useState('');
    const [selectedQRType, setSelecetdQRType] = useState({ id: 0, name: '' });

    const fileInputRef = useRef(null);

    useEffect(() => {
        setBulkAddData(formattedData)
    }, [formattedData, setBulkAddData])

    const setEditDetails = (data) => {
        setUserName(data?.name || '');
        setEmail(data?.email || '');
        setCredentialId(data?.credential_id || '');
        setSelecetdFormat(formats?.find(f => f?.id === data?.format) || { id: '', name: '' })
        setCredUpdate({ show: true, data: data })
        setSelecetdQRType((qrMode === "1" ? staticQRTypes : dynamicQRTypes)?.find(f => f?.name === data?.qrType) || { id: '', name: '' })
    }

    const columns = [
        // {
        //     title: 'Format',
        //     field: 'format',
        //     render: (col, data) => {
        //         return cardFormatMap[data?.format]?.name || data?.format || '-'
        //     }
        // },
        {
            title: 'Email',
            field: 'email',
        },
        {
            title: 'Name',
            field: 'name',
        },
        ...[...(assignmentMethod?.id === 2 ? [{ title: 'Credential ID', field: 'credential_id' }] : [])],
        ...[...(credentialType?.id === 'qr' ? [{ title: 'QR Type', field: 'qrType' }] : [])],
        {
            title: 'Error Message',
            field: 'errorMessage',
            render: (col, data) => {
                return <p style={{ color: 'red', whiteSpace: 'initial' }}>{data?.errorMessage}</p>
            }
        },
        {
            title: 'Actions',
            field: 'actions',
            render: (col, data, i) => {
                return (
                    <div className="button-row">
                        <IconButton onClick={() => { setEditDetails(data) }}>
                            <Edit />
                        </IconButton>
                        <IconButton onClick={() => { setCredDelete({ show: true, data: data }) }}>
                            <Delete />
                        </IconButton>
                    </div>
                )
            }
        },
    ];

    useEffect(() => {
        if (bulkSteps === 3) {
            const credsList = [];
            const qrTypes = qrMode === "1" ? staticQRTypes : dynamicQRTypes;
            const qrTypeMap = qrTypes.reduce((acc, item) => {
                acc[item.name] = item;
                return acc;
            }, {});

            credsData?.forEach((row, index) => {
                let creds = {};

                for (const key in headersMap) {
                    const text = headersMap[key]?.id
                    creds[key] = row[text] !== undefined ? String(row[text])?.trim()?.replace("--", "") : "";
                }

                creds = { id: index, ...creds, format: 'generic_32_bit' };
                creds['errorMessage'] = validateCredsData(creds, assignmentMethod?.id, qrTypeMap, credentialType?.id);
                if (creds?.errorMessage !== '-') {
                    creds['props'] = { 'data-highlight': 'error' };
                } else {
                    delete creds?.props
                }
                credsList.push(creds);
            });
            setFormattedData(detectDuplicateEmails(credsList))
        }
    }, [bulkSteps, headersMap, credsData, assignmentMethod?.id])

    const onTargetClick = () => {
        fileInputRef.current.click();
    };

    const hDeleteEntry = () => {
        setFormattedData(formattedData?.filter(fd => fd?.id !== credDelete?.data?.id) || []);
        setCredDelete(prev => ({ ...prev, show: false }))
    }


    const handleDownload = async () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(`Credential_templates_${assignmentMethod?.id === 2 ? 'Existing' : 'Generate'}`);
        const listSheet = workbook.addWorksheet("__lists");
        // listSheet.state = "hidden";
        const today = new Date();

        // formats.forEach((r, i) => {
        //     listSheet.getCell(`A${i + 1}`).value = r.name;
        // });

        // ------------------ HEADERS ------------------
        const headers = [];
        let emailCol = 68;

        headers.push(
            // {
            //     header: "Format",
            //     key: "format",
            //     required: true,
            //     validation: {
            //         type: "list",
            //         allowBlank: true,
            //         showDropDown: true,
            //         errorTitle: "Invalid Selection",
            //         error: "Select a valid Format",
            //         formulae: [`__lists!$A$1:$A$${formats.length}`],
            //     },
            // },
            {
                header: "Email",
                key: "email",
                required: true,
                validation: {
                    type: "custom",
                    allowBlank: true,
                    showErrorMessage: true,
                    errorTitle: "Invalid Email",
                    error: "Please enter a valid email address",
                    formulae: [
                        `=AND(ISNUMBER(SEARCH("@",A4)), ISNUMBER(SEARCH(".",A4)), NOT(ISNUMBER(SEARCH(" ",A4))), LEFT(A4,1)<>"@", RIGHT(A4,1)<>".")`
                    ],
                },
            },
            { header: "Name", key: "name", required: true }
        )


        if (assignmentMethod?.id === 2) {
            headers.push({ header: "Credential ID", key: "credentialID", required: true })
        }

        if (credentialType?.id === "qr") {
            const qrTypes = qrMode === "1" ? staticQRTypes : dynamicQRTypes;
            qrTypes.forEach((r, i) => {
                listSheet.getCell(`B${i + 1}`).value = r.name;
            });

            headers.push({
                header: "QR Type",
                key: "qrType",
                required: true,
                validation: {
                    type: "list",
                    allowBlank: true,
                    showDropDown: true,
                    errorTitle: "Invalid Selection",
                    error: "Select a valid QR Type",
                    formulae: [`__lists!$B$1:$B$${qrTypes.length}`],
                },
            },)
        }

        const noteCell = sheet.getCell(1, 1)
        noteCell.value = `Fill each row with full name${assignmentMethod?.id === 2 ? ', Credential ID' : ''}${credentialType?.id === 'qr' ? ', QR Type' : ''} and valid email without leaving blanks`;
        noteCell.font = { name: 'Calibri', bold: true, size: 12 };

        const HEADER_ROW = 3;

        headers.forEach((h, index) => {
            const cell = sheet.getCell(HEADER_ROW, index + 1);
            cell.value = h.header;
            cell.font = { name: 'Calibri', bold: true, size: 12 };
            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'caced1' }
            };
            sheet.getColumn(index + 1).width =
                Math.max(h.header?.length ?? 12, 25);
        });


        // EMPTY ROWS
        const START_ROW = 4;
        const END_ROW = 1002;
        for (let i = START_ROW + 1; i <= END_ROW; i++) sheet.addRow({});

        // ------------------ VALIDATION PER COLUMN ------------------
        headers.forEach((h, index) => {
            if (!h.validation) return;
            const colLetter = sheet.getColumn(index + 1).letter;
            const range = `${colLetter}${START_ROW}:${colLetter}${END_ROW}`;
            sheet.dataValidations.add(range, h.validation);
        });

        // ------------------ DOWNLOAD ------------------
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Credential_templates_${assignmentMethod?.id === 2 ? 'Existing' : 'Generate'}`;
        document.body.appendChild(a);
        a.click();
        a.remove();

        setTimeout(() => URL.revokeObjectURL(url), 3000);
    };

    const onFile = async (files) => {
        if (files) {
            const fileName = files[0].name;
            const fileExtension = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length);

            if (fileExtension !== 'xlsx') {
                dispatch(doCreateNotification({ isVisible: true, message: 'Please upload .xlsx files only' }));
            } else {
                try {
                    const buffer = await files[0].arrayBuffer();
                    const workbook = new ExcelJS.Workbook();
                    await workbook.xlsx.load(buffer);

                    const worksheet = workbook.worksheets[0];

                    const headerRow = worksheet.getRow(3).values.slice(1);
                    const formattedHeaders = headerRow?.map(h => ({ id: String(h).toLowerCase().replace(/\s+/g, "_"), name: h }));

                    const json = [];
                    worksheet.eachRow((row, rowIndex) => {
                        if (rowIndex > 3) {
                            const obj = {};
                            headerRow.forEach((header, i) => {
                                let value = row?.getCell(i + 1)?.value
                                value = value?.text || value;
                                const key = String(header).toLowerCase().replace(/\s+/g, "_");
                                obj[key] = value ? String(value).trim() : "";
                            });
                            json.push(obj);
                        }
                    });


                    setCredsData(json.map(elem => {
                        return {
                            ...elem,
                            format: elem?.format?.toLowerCase()?.replaceAll(' ', '_'),
                            credential_id: assignmentMethod?.id === 2 ? String(elem?.credential_id)?.toLowerCase()?.replaceAll(' ', '_') : undefined
                        }
                    }));

                    setCredsHeaders(formattedHeaders);

                    const iHead = (assignmentMethod?.id === 1 ? credType1Headers : credType2Headers).reduce((o, a, i) => {
                        o[a.name] = formattedHeaders[i];
                        return o;
                    }, {});

                    setHeadersMap(JSON.parse(JSON.stringify(iHead)));
                    setBulkSteps(2);
                } catch (err) {
                    dispatch(doCreateNotification({ isVisible: true, message: 'Error reading Excel file' }));
                }
            }
        } else {
            dispatch(doCreateNotification({ isVisible: true, message: 'Please upload a file' }));
        }
    };

    const hChange = (name, val) => {
        setHeadersMap(prev => ({
            ...prev,
            [name]: val,
        }));
    };

    const hUpdateCredential = () => {
        const updatedCreds = formattedData?.map(fd => {
            if (fd?.id === credUpdate?.data?.id) {
                return {
                    ...fd,
                    credential_id: credentialId,
                    email: email,
                    name: userName,
                    errorMessage: "-",
                    format: selectedFormat?.id,
                    qrType: selectedQRType?.name,
                    props: {}
                }
            }
            return fd;
        })
        setFormattedData(detectDuplicateEmails(updatedCreds));
        setCredUpdate(prev => ({ ...prev, show: false }))
    }

    const validateUpdateCreds = useMemo(() => {
        if (!email || !userName?.trim() || !selectedFormat?.id || !validEmail(email)) {
            return true;
        }
        if (assignmentMethod?.id === 2 && (!credentialId || !(/^\d+$/.test(credentialId)))) {
            return true;
        }
        return false
    }, [email, userName, selectedFormat?.id, credentialId, assignmentMethod?.id])

    const renderSteps = () => {
        switch (bulkSteps) {
            case 1:
                return (
                    <FlexColumn gap="0" alignItems="start" className="bulk-container">
                        <div className='row text-container'>
                            <p>Download the template file</p>
                            <OutlineButton style={{ width: '6rem' }} type='tertiary' shadow={false} text='Download' onClick={handleDownload} />
                        </div>
                        <p className='b-info'>Enter UID details for the credentials</p>
                        <FileDrop onDrop={onFile} onTargetClick={onTargetClick}>
                            <div htmlFor="uploadFile" className='column drop-container'>
                                <FileUpload />
                                <p><span style={{ color: '#3995E5', fontWeight: '600' }}>Click to upload</span> or drag and drop</p>
                                <p>Upload only .xlsx files</p>
                                <input
                                    onChange={(e) => onFile(e.target.files, e)}
                                    ref={fileInputRef}
                                    type="file"
                                    style={{ display: 'none' }}
                                    id="uploadFile"
                                />
                            </div>
                        </FileDrop>
                    </FlexColumn>
                );
            case 2:
                return (
                    <FlexColumn alignItems="start" >
                        <div className='row text-container'>
                            <p>Header Mapping</p>
                        </div>
                        <Grid container spacing="3">
                            {(assignmentMethod?.id === 1 ? credType1Headers : credType2Headers)?.filter(t => {
                                if (credentialType?.id !== 'qr' && t?.name === 'qrType') {
                                    return false;
                                }
                                return true
                            }).map((t, i) => (
                                <Grid key={t.name} container item md={6}>
                                    <Dropdown
                                        text={t.text}
                                        name={t.name}
                                        placeholder={t.text}
                                        value={headersMap[t.name]?.name || ''}
                                        onChange={(val) => hChange(t?.name, val)}
                                        data={credsHeaders}
                                        helpText={t.name + ' is required'}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </FlexColumn>
                )
            case 3:
                return (
                    <Table
                        columns={columns}
                        data={formattedData || []}
                        defaultMessage={'No Credentials Found'}
                    />
                )
            default:
                return null;
        }
    }

    return (
        <>
            {renderSteps()}
            {/* Delete dialog */}
            <Dialog open={credDelete?.show} maxWidth={'sm'} fullWidth={true} scroll={'body'}>
                <DialogTitle>
                    <Typography variant="h6">Are you sure you want to delete the Entry?</Typography>
                </DialogTitle>
                <DialogContent style={{ margin: '1rem 0' }}>
                    <Typography style={{ backgroundColor: '#2196f3', width: 'fit-content', color: 'white', padding: '0.3rem 0.7rem', borderRadius: '0.5rem' }} variant="h6">{credDelete?.data?.email}</Typography>
                </DialogContent>
                <Divider />
                <DialogActions style={{ padding: '1rem 2rem' }}>
                    <OutlineButton shadow={false} text='Cancel' onClick={() => { setCredDelete(prev => ({ ...prev, show: false })) }} />
                    <Button buttonType={'danger'} shadow={false} text={'Delete'} onClick={() => { hDeleteEntry() }} />
                </DialogActions>
                <Grid className="spacer__0-5" />
            </Dialog>

            {/* Update dialog */}
            <Dialog open={credUpdate?.show} maxWidth={'sm'} fullWidth={true} scroll={'body'}>
                <DialogTitle>
                    <Typography variant="h6">Edit Credential</Typography>
                </DialogTitle>
                <DialogContent style={{ margin: '1rem 0' }}>
                    <GenerateNewCredential
                        mode={2}
                        assignmentMethod={assignmentMethod}
                        setCredentialId={setCredentialId}
                        credentialId={credentialId}
                        email={email}
                        userName={userName}
                        setUserName={setUserName}
                        setEmail={setEmail}
                        selectedFormat={selectedFormat}
                        setSelecetdFormat={setSelecetdFormat}
                        qrMode={qrMode}
                        selectedQRType={selectedQRType}
                        setSelecetdQRType={setSelecetdQRType}
                        credentialType={credentialType}
                    />
                </DialogContent>
                <Divider />
                <DialogActions style={{ padding: '1rem 2rem' }}>
                    <OutlineButton shadow={false} text='Cancel' onClick={() => { setCredUpdate(prev => ({ ...prev, show: false })) }} />
                    <Button disabled={validateUpdateCreds} shadow={false} text={'Update'} onClick={hUpdateCredential} />
                </DialogActions>
                <Grid className="spacer__0-5" />
            </Dialog>
        </>
    )
};

export default BulkUploadCredential;
